import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import SectionForm from '../section-form';
import SectionsList from '../sections-list';

export default function LessonSections({
    lesson,
    selectedSection,

    onCreate,
    onDelete,
    onReorder
}) {
    const [section, setSection] = useState(selectedSection);
    const [isFormOpen, toggleFormOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    const handleCreate = useCallback(data => {
        return onCreate(data)
            .finally(() => toggleFormOpen(false));
    }, [onCreate, toggleFormOpen]);

    const handleDelete = useCallback(() => {
        return onDelete(section)
            .finally(() => toggleConfirmationDialogOpen(false));
    }, [section, onDelete, toggleConfirmationDialogOpen]);

    const handleReorder = useCallback((index, dir) => {
        const sections = lesson._sections.slice();
        const section = sections[index];
        const otherSection = sections[index + dir];

        sections[index + dir] = section;
        sections[index] = otherSection;

        onReorder({ _sections: sections });
    }, [lesson, onReorder]);

    const handleDeleteRequest = useCallback(section => {
        setSection(section);
        toggleConfirmationDialogOpen(true);
    }, [toggleConfirmationDialogOpen]);

    return (
        <PageSection
            className="LessonSections"
            title="Секции"
            actions={[{
                key: 'add',
                icon: 'add',
                title: 'Добавить секцию',
                onClick: toggleFormOpen
            }]}
            compact
        >
            {lesson.sections?.length > 0 &&
                <SectionsList
                    sections={lesson.sections}
                    selectedSection={selectedSection}
                    onSelect={selectedSection && setSection}
                    onReorder={handleReorder}
                    onDelete={handleDeleteRequest}
                />
            }

            <FormDialog
                title="Новая секция"
                open={isFormOpen}
                onClose={toggleFormOpen}
            >
                <SectionForm
                    id="section-form"
                    onSubmit={handleCreate}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Удалить секцию?"
                message={section && `Секция "${section.title}" будет удалена без возможности восстановления.`}
                open={isConfirmationDialogOpen}
                onConfirm={handleDelete}
                onClose={toggleConfirmationDialogOpen}
            />
        </PageSection>
    );
}